import React from "react";
import "./popup.css";
import { Icon } from "@iconify/react/dist/iconify.js";

const Popup = ({ message, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-icon">
          <Icon icon="mdi:check-circle" width="2.5rem" height="2.5rem" />
        </div>
        <p className="popup-message">{message}</p>
        <button onClick={onClose} className="popup-close-button">
          Done
        </button>
      </div>
    </div>
  );
};

export default Popup;
